import styled from 'styled-components';

import { device, typography } from '@/styles/helpers';

export const ScHowToParticipateSection = styled.div`
  margin-top: 44px;

  @media (${device.mobile}) {
    margin-top: 14px;
  }

  & > .cards {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 12px;

    @media (${device.mobile}) {
      flex-direction: column;
    }
  }
`;

export const ScHowToParticipateSectionTitle = styled.h2`
  ${typography['headline2']}
  text-align: center;
  color: ${({ theme }) => theme.whiteColor};
  margin-bottom: 34px;
  text-transform: uppercase;

  @media (${device.mobile}) {
    ${typography['headline2mobile']}
    margin-bottom: 24px;
  }
`;

export const ScHowToParticipateSectionCard = styled.div`
  position: relative;
  width: 256px;
  height: 182px;
  padding: 43px 19px;

  & > .title,
  & > .description {
    position: relative;
  }

  & > .title {
    ${typography['body1bold']}
    color: ${({ theme }) => theme.whiteColor};
  }

  & > .description {
    margin-top: 8px;
    ${typography['body2regular']}
    font-weight: 400;
    letter-spacing: 0em;
    color: ${({ theme }) => theme.manateeColor};
  }
  & > .label {
    position: absolute;
    bottom: 4px;
    right: 4px;

    display: flex;
    padding: 4px 8px;
    justify-content: center;
    align-items: center;
    border-radius: 20px;

    ${typography['caption2bold']}
    color: ${({ theme }) => theme.success};
    background: rgba(26, 178, 50, 0.2);
  }
`;
